module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/redzel.440f952.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/redzel.jpg
// module id = JPtl
// module chunks = 0